module.exports = __webpack_public_path__ + "img/logo-year.74bf2b29.svg";